import { render, staticRenderFns } from "./ExportsDashboard.vue?vue&type=template&id=2b956d37&"
import script from "./ExportsDashboard.vue?vue&type=script&lang=js&"
export * from "./ExportsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports